<template>
    <div class="work" v-if="loaded && ready">
      <hero-work :lang="lang" :workData="workData" ></hero-work>
      <work-proj :lang="lang" v-if="loaded2 && ready" :doneScreen="doneScreen"  :tags="tags" :projects="projects">   </work-proj>

      <div class="content-footer-work" >
        <footer-nossa :lang="lang" :isMobile="isMobile"></footer-nossa>
      </div>
    </div>
</template>

<script>


    import {NavEvents} from "../dataModules/NavEvents";
    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, WP, getDeskProj, setDeskProj} from '../main';
    import WorkProj from "./Modules/WorkProj";
    import HeroWork from "./Modules/HeroWork";
    import FooterNossa from "./FooterNossa";



    export default {

        name: 'work',
      components: {FooterNossa, HeroWork, WorkProj},
      props: ['actRoute', 'isMobile', 'lang'],
      watch: {
        '$route' (to, from) {


          this.hasHash(to)
        }
      },
        data() {
            return {
                actScreen:0,
              actualProj: 0,
              workData: [],
              loaded: false,
              loaded2: false,
              ready: false,

              incPagePos: 0,
              stopInc: false,
              totalScreens: 2,
              actualScreen: 0,

              footerVisited : '',
              main: {},
              stopSwipe: false,
              doneScreen: '',
              tags: [],
              projects: [],
              firstTime : true,

            }
        },

      head: {
        title: function () {
          const _this = this;
          return {
            inner: 'NOSSA™',   separator: '|',   complement: 'Ideias'
          }
        },


      },

      created() {

          const _this = this;



        WP('work', function (response){

          _this.workData = response[0];



          console.log(_this.workData)

          _this.loaded = true;

          WP('projects', function (response){


            for(let i = 0; i <= response.length; i++){
            console.log(response[i].cover.img);
            }

            _this.projects = response;
            WP('tags', function (response){
              _this.tags = response;
              _this.loaded2 = true;
              _this.init();
            });
          });




        });

      },
      mounted() {
        this.ready = true;
        this.init();
        //EVENTBUS.$on('AAA', AAA);
        //EVENTBUS.$emit('AAA', 0);
        $(window).scrollTop(0);
        $('body, html').scrollTop(0);

        window.addEventListener('resize', this.resizeMe);


      },

      destroyed() {
        window.removeEventListener('resize', this.resizeMe);
        this.navEvt.wheelSwitch(false);

      },

      methods: {

        resizeMe(){
          this.movePage(this.actualScreen);
        },

        init() {
          const _this = this;
          if(this.loaded && this.ready){

            _this.hasHash(_this.$route)


          }
        },


        hasHash(route){


          const _this = this;


          if(_this.firstTime){
            _this.navEvt = new NavEvents(document.getElementById('main'), this.incPageEVTByPass, false);
            _this.firstTime = false;
          }


          if(route.hash == ''){
            _this.actualScreen = 0;
            _this.navEvt.wheelSwitch(true);
          }else{
            let dec =  decodeURI(route.hash)
           let _hs =  dec.substr(1)

            _this.actualScreen = 1;
            _this.movePage(0.3);
            setTimeout(function () {
              _this.navEvt.wheelSwitch(true);
              EVENTBUS.$emit('getActiveTag', _hs);
            }, 200);
          }







        } ,

        incPageEVTByPass(n){
          let  obj = getDeskProj();

          console.log(this.actualScreen, obj.act, obj.total, n)

          //  console.log(obj)
          if(this.actualScreen == 0 || this.actualScreen == 2) {

            this.incPageEVT(n);


          }else if(this.actualScreen == 1){

            if(obj.act == 0 && n == 0){
              this.incPageEVT(n);

            } else if(obj.act == (obj.total - 1) && n == 1){
               this.incPageEVT(n);
            }else{
              EVENTBUS.$emit('evtMasterNavigate', n);
            }
          }









        },

        incPageEVT(n){


          if(this.actualScreen > 0 && n === 0){
            this.actualScreen --;
          }

          if(this.actualScreen < this.totalScreens && n === 1){
            this.actualScreen ++;
          }

          this.movePage();


          // this.stopInc = true;


        },



        movePageByPass(){

          /*

          totalScreens: 3,
              totalProj: 3,
              actualScreen: 0,
              actualProj: 0,

          EVENTBUS.$emit('incHomeProj', 0);
           */


        },

        movePage(vel = 0.8){

          const _this = this;

          //  console.log(_this.actualScreen + ' move ' + _this.totalScreens)

          let ref = 0

          if(_this.actualScreen < _this.totalScreens){
            ref = 0 - (_this.actualScreen * window.innerHeight);
          }else{
            ref = 0 - ((_this.actualScreen - 1) * window.innerHeight);
            ref -=420;
          }



        //  console.log('_this.actualProj: ' + _this.actualProj)

          EVENTBUS.$emit('pauseVid');
         //his.wheelSwitch(false);
          this.controlPages(_this.actualScreen);

          TweenMax.to( '.work', vel, {y: ref , force3D: true, ease:  "sine.inOut"} );





        },


        controlPages(n){
          const _this = this;





          if(n == 1) {

            setTimeout(function(){
              _this.doneScreen = 'done';
            }, 600);



        //    EVENTBUS.$emit('control-proj-home', true);
          }else{
          //  EVENTBUS.$emit('control-proj-home', false);
          }

          if(n == 2) {

            /*
            setTimeout(function(){
              _this.destakVisited = 'visited';
            }, 300);
*/

            setTimeout(function(){
              EVENTBUS.$emit('showFooter');

            }, 300);

          }
          if(n == 3) {



          }

        }



      },
    };

</script>


// WEBPACK FOOTER //
// src/components/Work.vue